import { AdminData } from './types';

export const getAdminFullName = ({ firstName, lastName }: Pick<Partial<AdminData>, 'firstName' | 'lastName'>) =>
  `${firstName} ${lastName}`;
